// extracted by mini-css-extract-plugin
module.exports = {"panel":"Index_panel__5I3e8","time":"Index_time__2HFLy","inside-divider":"Index_inside-divider__3QXwO","avatar":"Index_avatar__2ePGM","divider":"Index_divider__3C5I-"};